// extracted by mini-css-extract-plugin
export default {"root":"addExam_root__wFANZ","wrapper":"addExam_wrapper__vDWke","left":"addExam_left__3ADND","Empty":"addExam_Empty__0KGhm","tip":"addExam_tip__CHdKI"};